import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

interface IArgs {
  app;
  router;
  releaseName: string;
}
export const initSentry = (args: IArgs) => {
  console.log("初始化sentry process.env.VUE_APP_DATETIME");
  const { app, router, releaseName } = args;
  Sentry.init({
    app,
    dsn: "https://7bee5770baf64016bf49bd0c30ab8076@monitor.aiyouyi.cn/138",
    debug: false, // 错误调试，在控制台打印错误
    attachStacktrace: true,
    release: `v_${releaseName}_${String(Date.now())}`, // soureMap文件对应名
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [
          "localhost",
          "pre-partner.gmarketing.tech",
          "www.partnermarketing.cn",
          /^\//,
        ], // 设置“tracePropagationTargets”以控制应为哪些URL启用跟踪传播
      }),
    ],
    // allowUrls: ["http://localhost:8080", "https://biz.ceboss.cn", "https://pre-biz.ceboss.cn"],
    sampleRate: 1, // 决定sentry错误抓取的百分比，范围时0~1，比如今天项目报了100个错误，你配置的0.5，那么sentry随机给你上报50个。
    tracesSampleRate: 1.0, // 关闭性能上报，建议使用tracesSampler设置上报白名单，全开启会使sentry崩溃
    ignoreErrors: [
      // 不需要上报的错误
      "Failed to fetch",
      "NetworkError when attempting to fetch resource.",
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      "Loading chunk",
      "Unable to preload CSS for",
      "Request aborted",
      "Network Error",
      "Cannot read properties of undefined",
      "n.flatMap is not a function",
    ],
  });
  (window as any).$sentry = Sentry;
};
